import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export type IconButtonSize = 'xs' | 'sm' | 'md' | 'lg';
export type IconButtonShape = 'circle' | 'square';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required — these buttons carry no visible label. */
  label: string;
  size?: IconButtonSize;
  shape?: IconButtonShape;
}

/** 26px passenger steppers, 32px sheet close, 34px swap, 38px header actions. */
const SIZE: Record<IconButtonSize, string> = {
  xs: 'w-[26px] h-[26px]',
  sm: 'w-8 h-8',
  md: 'w-[34px] h-[34px]',
  lg: 'w-[38px] h-[38px]',
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, size = 'lg', shape = 'circle', className, type = 'button', children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      title={label}
      aria-label={label}
      className={cn(
        'relative inline-flex flex-none cursor-pointer items-center justify-center',
        'border border-line bg-surface text-muted',
        'transition-colors duration-fast ease-standard hover:bg-hover',
        'disabled:cursor-not-allowed disabled:opacity-40',
        shape === 'circle' ? 'rounded-full' : 'rounded-md',
        SIZE[size],
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
});
